//good job block

// Please Note, most of functinality of this component is directly used from ChatGPT just for Demo. WHile actual API implementation
import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Container,
  Input,
  FormGroup,
  Label,
  Tooltip,
  ButtonGroup,
  Button,
  Popover,
  PopoverHeader,
  PopoverBody,
} from "reactstrap";
import { JobSlotCard } from "./CreateJobModal";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { techniciansList, regionList } from "constants/technicians";
import { getTechniciansList, getRegionList } from "actions/technicians";
import { getTimeSlotsList } from "actions/technicianAvailability";
import { timeSlotsList } from "constants/techncianAvailabilty";
import { getJobList } from "actions/job";
import { jobList } from "constants/job";
import moment from "moment";
import { urlEncodedId } from "components/Common/encodeDecodeFunction";
import { QUOTATION } from "API/apiConstants";
import { getAllTechnicians } from "actions/technicians";
import { WORK_ORDER } from "components/Common/constants";

import Select, { components } from "react-select";
import { fixedWidthCustomStyle } from "components/Common/constants";
import { selectStyles } from "components/Common/constants";

const formatSchedulerStatus = (status) => String(status || "-")
  .replace(/\bJOB(?=_|\b)/g, "WORK_ORDER");

const legendItems = [
  // { label: "Repair", status: "repair" },
  // { label: "Inspection", status: "inspection" },
  // { label: "Emergency", status: "emergency" },
  // { label: "Maintenance", status: "maintenance" },
  { label: `${WORK_ORDER} Allocated`, status: "job-allocated" },
  { label: "Request Approval", status: "request-approval" },
  { label: "Request Parts", status: "request-parts" },
  { label: "Repair", status: "job-repair" },
  { label: "Repaired", status: "job-repaired" },
  { label: "Quotation InProgress", status: "quotation-inprogress" },
  { label: "Quotation Rejected", status: "quotation-rejected" },
  { label: "Quotation Accepted", status: "quotation-accepted" },
  { label: "Invoice (Not Paid)", status: "invoice-not-paid" },
  { label: "Invoice (Paid)", status: "invoice-paid" },
  { label: "Cancelled", status: "job-cancelled" },
  { label: "Work Order Rejected by client", status: "job-rejected-by-client" },
  // { label: "Completed", status: "job-completed" },
];

// Weekday labels
const weekDays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

// Generate 24-hour slots

const JobScheduler = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const technicianListData = useSelector(
    (state) => state.technicians.techniciansList,
  );
  const timeSlotList = useSelector(
    (state) => state.technicianAvailability.timeSlotsList,
  );

  const regionListData = useSelector((state) => state.technicians.regionList);
  const jobListData = useSelector((state) => state.job.jobList);

  const allTechnicianListData = useSelector(
    (state) => state.technicians.allTechnicians,
  );

  const [tooltipOpen, setTooltipOpen] = useState({});
  const [view, setView] = useState("Timeline"); // Timeline | Day | Week | Month
  const toggleTooltip = (id) => {
    setTooltipOpen((prev) => ({ ...prev, [id]: !prev[id] }));
  };
  const [popoverOpen, setPopoverOpen] = useState(null);
  const [currentTimeLeft, setCurrentTimeLeft] = useState(0);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [weekDays, setWeekDays] = useState([]);
  const [monthDays, setMonthDays] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [reloadPage, setreloadPage] = useState(false);
  const [selectDropdownValues, setselectDropdownValues] = useState({
    region: 1,
    technician: "",
  });

  // Job data with type and weekday
  const jobs =
    (jobListData?.data?.job || []).filter((job) => job.jobStatus !== "COMPLETED",);

  // Map job type to color class
  const jobColor = {
    JOB_ALLOCATED: "job-allocated",
    REQUEST_APPROVAL: "request-approval",
    PART_REQUESTS: "request-parts",
    REPAIR: "job-repair",
    REPAIRED: "job-repaired",
    QUOTATION_IN_PROGRESS: "quotation-inprogress",
    QUOTATION_REJECTED: "quotation-rejected",
    QUOTATION_ACCEPTED: "quotation-accepted",
    INVOICE_NOT_PAID: "invoice-not-paid",
    INVOICE_PAID: "invoice-paid",
    CANCELLED: "job-cancelled",
    COMPLETED: "job-completed",
    JOB_REJECTED_BY_CLIENT:"job-rejected-by-client"
  };

  // currently i have used it from chatgpt once other functions are done i will refactor it properly
  useEffect(() => {
    const updateTimeLine = () => {
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      const totalHours = hours + minutes / 60;

      // 🔹 Common percentage for both views
      const percent = (totalHours / 24) * 100;
      setCurrentTimeLeft(percent);

      // 🔹 For timeline (horizontal layout)
      const timeGrids = document.querySelectorAll(".time-grid");
      timeGrids.forEach((grid) => {
        const line = grid.querySelector(".current-time-line");
        if (line) line.style.left = `${percent}%`;
      });

      // 🔹 For day view (vertical layout)
      const dayGrids = document.querySelectorAll(".hour-grid");
      dayGrids.forEach((grid) => {
        const line = grid.querySelector(".current-time-line");
        if (line) line.style.top = `${percent}%`;
      });
    };

    // Initial run
    updateTimeLine();

    // ⏱ Update every minute + resize
    const interval = setInterval(updateTimeLine, 60000);
    window.addEventListener("resize", updateTimeLine);

    return () => {
      clearInterval(interval);
      window.removeEventListener("resize", updateTimeLine);
    };
  }, []);

  useEffect(() => {
    getRegionList(dispatch);
    getTimeSlotsList(dispatch);

    return () => {
      dispatch({ type: techniciansList, payload: {} });
      dispatch({ type: regionList, payload: {} });
      dispatch({ type: timeSlotsList, payload: {} });
      dispatch({ type: jobList, payload: {} });
    };
  }, [dispatch]);

  useEffect(() => {
    if (selectDropdownValues.region !== "") {
      let filterJSON = [];

      if (selectDropdownValues.region !== 0) {
        filterJSON.push({
          field: "RegionID",
          condition: "eq",
          filterValues: [String(selectDropdownValues.region)],
        });
      }

      filterJSON.push({
        field: "UserStatus",
        condition: "eq",
        filterValues: ["ACTIVE"],
      });
      getTechniciansList(dispatch, {
        filters: JSON.stringify(filterJSON),
      });

      getAllTechnicians(dispatch, {
        filters: JSON.stringify(filterJSON),
      });
      //=========Job List
      // let formattedDate = moment(currentDate).format("YYYY-MM-DD");
      // let DatefilterJSON = [
      //   {
      //     field: "ScheduledTo",
      //     condition: "btw",
      //     filterValues: [String(formattedDate), String(formattedDate)],
      //   },
      //   {
      //     field: "RegionID",
      //     condition: "eq",
      //     filterValues: [String(selectDropdownValues.region)],
      //   },
      // ];
      // getJobList(dispatch, { filters: JSON.stringify(DatefilterJSON) });
    }
  }, [selectDropdownValues.region, reloadPage]);

  useEffect(() => {
    if (selectDropdownValues.technician !== "") {
      let filterJSON = [];
      if (selectDropdownValues.technician !== 0) {
        filterJSON.push({
          field: "TechnicianID",
          condition: "eq",
          filterValues: [String(selectDropdownValues.technician)],
        });
      }

      if (selectDropdownValues.region !== 0) {
        filterJSON.push({
          field: "RegionID",
          condition: "eq",
          filterValues: [String(selectDropdownValues.region)],
        });
      }

      filterJSON.push({
        field: "UserStatus",
        condition: "eq",
        filterValues: ["ACTIVE"],
      });

      getTechniciansList(dispatch, {
        filters: JSON.stringify(filterJSON),
      });

      // let formattedDate = moment(currentDate).format("YYYY-MM-DD");
      // let DatefilterJSON = [
      //   {
      //     field: "ScheduledTo",
      //     condition: "btw",
      //     filterValues: [String(formattedDate), String(formattedDate)],
      //   },
      // ];
      // getJobList(dispatch, { filters: JSON.stringify(DatefilterJSON) });
    }
  }, [selectDropdownValues.technician]);

  useEffect(() => {
    // Reapply position when view changes
    const timeGrids = document.querySelectorAll(".time-grid");
    const dayGrids = document.querySelectorAll(".hour-grid");

    timeGrids.forEach((grid) => {
      const line = grid.querySelector(".current-time-line");
      if (line) line.style.left = `${currentTimeLeft}%`;
    });

    dayGrids.forEach((grid) => {
      const line = grid.querySelector(".current-time-line");
      if (line) line.style.top = `${currentTimeLeft}%`;
    });
  }, [view, currentTimeLeft]);

  useEffect(() => {
    if (view === "Week") {
      const startOfWeek = new Date(currentDate);
      const day = currentDate.getDay();
      const diffToMonday = day === 0 ? -6 : 1 - day;
      startOfWeek.setDate(currentDate.getDate() + diffToMonday);

      const days = [];
      for (let i = 0; i < 7; i++) {
        const d = new Date(startOfWeek);
        d.setDate(startOfWeek.getDate() + i);
        days.push({
          label: d.toLocaleDateString("en-US", { weekday: "short" }),
          date: d,
        });
      }
      const startDayOfWeek = moment(startOfWeek).format("YYYY-MM-DD");
      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6);
      const endDayOfWeek = moment(endOfWeek).format("YYYY-MM-DD");
      let filterJSON = [
        {
          field: "ScheduledTo",
          condition: "btw",
          filterValues: [String(startDayOfWeek), String(endDayOfWeek)],
        },
      ];
      getJobList(dispatch, { filters: JSON.stringify(filterJSON) });
      setWeekDays(days);
      // setreloadPage(false);
    }

    if (view === "Month") {
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth();
      const firstDay = new Date(year, month, 1);
      const lastDay = new Date(year, month + 1, 0);
      const days = [];
      for (let i = 1; i <= lastDay.getDate(); i++) {
        days.push({
          label: i,
          date: new Date(year, month, i),
        });
      }
      const firstDayofMonth = moment(firstDay).format("YYYY-MM-DD");
      const lastDayofMonth = moment(lastDay).format("YYYY-MM-DD");
      let filterJSON = [
        {
          field: "ScheduledTo",
          condition: "btw",
          filterValues: [String(firstDayofMonth), String(lastDayofMonth)],
        },
      ];
      getJobList(dispatch, { filters: JSON.stringify(filterJSON) });
      // setreloadPage(false);
      setMonthDays(days);
    }
    if (view == "Day" || view == "Timeline") {
      let formattedDate = moment(currentDate).format("YYYY-MM-DD");
      let filterJSON = [
        {
          field: "ScheduledTo",
          condition: "btw",
          filterValues: [String(formattedDate), String(formattedDate)],
        },
      ];
      getJobList(dispatch, { filters: JSON.stringify(filterJSON) });
      // setreloadPage(false);
    }
  }, [currentDate, view, reloadPage]);

  const handleAddNewJob = (tech, time, currentDate, edit = false) => {
    setSelectedSlot({ tech, time, currentDate, edit, view });
  };

  const handleEditJob = (job, edit = true) => {
    setSelectedSlot({ job, edit, currentDate });
  };

  const handleDateChange = (direction) => {
    const newDate = new Date(currentDate);
    switch (view) {
      case "Timeline":
      case "Day":
        // Move one day forward or backward
        newDate.setDate(
          currentDate.getDate() + (direction === "next" ? 1 : -1),
        );
        break;

      case "Week":
        // Move one week (7 days) forward or backward
        newDate.setDate(
          currentDate.getDate() + (direction === "next" ? 7 : -7),
        );
        break;

      case "Month":
        // Move one month forward or backward
        newDate.setMonth(
          currentDate.getMonth() + (direction === "next" ? 1 : -1),
        );
        break;

      default:
        break;
    }
    setCurrentDate(newDate);
  };

  const getDayName = (date) =>
    ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][date.getDay()];

  // const currentDayName = getDayName(currentDate);
  // const filteredJobs = jobs.filter((j) => j.day === currentDayName);

  // Determine which jobs to show based on view

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const getFilteredJobs = (jobs, currentDate, view) => {
    if (!jobs || !currentDate) return [];

    const selectedDate = new Date(currentDate);
    selectedDate.setHours(0, 0, 0, 0);

    const parseJobDate = (dateString) => {
      const date = new Date(dateString);
      return date;
    };

    switch (view) {
      // ==========================
      // ✅ DAY / TIMELINE
      // ==========================
      case "Day":
      case "Timeline":
        return jobs.filter((job) => {
          const jobDate = new Date(job.scheduledFrom);

          return (
            jobDate.getFullYear() === selectedDate.getFullYear() &&
            jobDate.getMonth() === selectedDate.getMonth() &&
            jobDate.getDate() === selectedDate.getDate()
          );
        });

      // ==========================
      // ✅ WEEK
      // ==========================
      case "Week": {
        const startOfWeek = new Date(selectedDate);
        const day = startOfWeek.getDay();
        const diffToMonday = day === 0 ? -6 : 1 - day;

        startOfWeek.setDate(startOfWeek.getDate() + diffToMonday);
        startOfWeek.setHours(0, 0, 0, 0);

        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(endOfWeek.getDate() + 6);

        return jobs.filter((job) => {
          const jobDate = new Date(job.scheduledFrom);
          return jobDate >= startOfWeek && jobDate <= endOfWeek;
        });
      }

      // ==========================
      // ✅ MONTH
      // ==========================
      case "Month":
        return jobs.filter((job) => {
          const jobDate = parseJobDate(job.scheduledFrom);
          return (
            jobDate.getFullYear() === selectedDate.getFullYear() &&
            jobDate.getMonth() === selectedDate.getMonth()
          );
        });

      default:
        return jobs;
    }
  };

  const filteredJobs = getFilteredJobs(jobs, currentDate, view);

  // useEffect(() => {
  //   if (regionListData?.data?.region.length > 0) {
  //     setselectDropdownValues((prev) => ({
  //       ...prev,
  //       region: regionListData?.data.region[0]?.ID,
  //     }));
  //   }
  // }, [regionListData]);

  const handleSelect = (key, value) => {
    setselectDropdownValues((prev) => ({
      ...prev,
      [key]: value === "All" ? 0 : Number(value),
    }));
  };

  const updatePage = () => {
    setreloadPage(!reloadPage);
  };

  const onClose = () => {
    setreloadPage(!reloadPage);
    setSelectedSlot(null);
  };

  // ✅ Single source of truth for the current time label
  const currentTimeLabel = new Date().toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  return (
    <Container fluid className="mt-4 job-scheduler">
      <Row>
        <Col md="12">
          <Card>
            <CardHeader className="d-flex align-items-center justify-content-between flex-wrap job-card-header">
              <CardTitle tag="h3" className="font-weight-normal mb-2">
                {WORK_ORDER} Scheduler
              </CardTitle>
              <div className="d-flex align-items-center flex-wrap">
                <ButtonGroup size="sm" className="mb-2">
                  {["Timeline", "Week", "Month"].map((mode) => (
                    //"Day" view is working but currently hidden it as it's similar to timeline view
                    <Button
                      key={mode}
                      color={view === mode ? "default" : "light"}
                      className={view === mode ? "btn" : "btn-simple"}
                      onClick={() => setView(mode)}
                    >
                      {mode}
                    </Button>
                  ))}
                </ButtonGroup>
              </div>
            </CardHeader>

            <CardBody className="pt-2 position-relative">
              <div className="d-flex align-items-center justify-content-between flex-wrap mb-4">
                <div className="d-flex align-items-center flex-wrap">

                  <div className="d-flex align-items-center flex-wrap filter-row">
                  <FormGroup className="mr-3 mb-2 d-flex align-items-center filter-form-group">
                    <Label for="region" className="mb-0 mr-2 small text-muted flex-shrink-0">
                      Region
                    </Label>
                    <Select
                      id="region"
                      className="filter-select"
                      options={[
                        ...(regionListData?.data?.region || []).map(t => ({
                          value: t.ID,
                          label: t.name
                        })),
                        { value: 0, label: "All" }
                      ]}
                      placeholder="Select Region"
                      classNamePrefix="react-select"
                      value={(() => {
                        const selected = selectDropdownValues.region;
                        if (selected === 0) return { value: 0, label: "All" };
                        const region = regionListData?.data?.region?.find(t => t.ID === selected);
                        return region ? { value: region.ID, label: region.name } : null;
                      })()}
                      onChange={(selected) => handleSelect("region", selected?.value || 0)}
                      styles={selectStyles}
                      menuPortalTarget={document.body}
                      isClearable={false}
                    />
                  </FormGroup>
                 

                  <FormGroup className="mr-3 mb-2 d-flex align-items-center filter-form-group">
                  <Label for="technician" className="mb-0 mr-2 small text-muted flex-shrink-0">
                    Technician
                  </Label>
                   <Select
                      id="technician"
                      className="filter-select"
                      options={[
                        { value: 0, label: "All" },
                        ...(allTechnicianListData?.data?.technician || []).map(t => ({
                          value: t.ID,
                          label: t.fullName
                        }))
                      ]}
                      placeholder="Select Technician"
                      classNamePrefix="react-select"
                      value={(() => {
                        const selected = selectDropdownValues.technician;
                        if (selected === 0 || !selected) return { value: 0, label: "All" };
                        const tech = allTechnicianListData?.data?.technician?.find(t => t.ID === selected);
                        return tech ? { value: tech.ID, label: tech.fullName } : { value: 0, label: "All" };
                      })()}
                      onChange={(selected) => handleSelect("technician", selected?.value || 0)}
                      styles={selectStyles}
                      menuPortalTarget={document.body} // This renders the menu in the body
                      isClearable={false}
                    />
                  </FormGroup>
                   </div>
                  {/* <FormGroup className="mr-3 mb-2">
                    <Label for="date" className="mb-0 small text-muted">
                      Date
                    </Label>
                    <Input type="date" id="date" bsSize="md" />
                  </FormGroup> */}

                  <div className="d-flex align-items-center justify-content-center mt-1">
                    <Button
                      color="link"
                      size="sm"
                      className="date-btn rounded-circle"
                      onClick={() => handleDateChange("prev")}
                    >
                      <i className="fa fa-less-than" />
                    </Button>

                    <Button
                      color="link"
                      size="sm"
                      className="date-btn rounded-circle"
                      onClick={() => handleDateChange("next")}
                    >
                      <i className="fa fa-greater-than" />
                    </Button>

                    <div className="mx-3 fw-semibold">
                      {view === "Timeline" || view === "Day"
                        ? currentDate.toLocaleDateString("en-GB", {
                          weekday: "long",
                          day: "2-digit",
                          month: "long",
                          year: "numeric",
                        })
                        : view === "Week"
                          ? (() => {
                            const startOfWeek = new Date(currentDate);
                            const endOfWeek = new Date(currentDate);

                            const day = currentDate.getDay();
                            const diffToMonday = day === 0 ? -6 : 1 - day;
                            startOfWeek.setDate(
                              currentDate.getDate() + diffToMonday,
                            );
                            endOfWeek.setDate(startOfWeek.getDate() + 6);

                            const startLabel = startOfWeek.toLocaleDateString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "long",
                              },
                            );
                            const endLabel = endOfWeek.toLocaleDateString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "long",
                                year: "numeric",
                              },
                            );

                            return `${startLabel} - ${endLabel}`;
                          })()
                          : view === "Month"
                            ? currentDate.toLocaleDateString("en-US", {
                              month: "long",
                              year: "numeric",
                            })
                            : null}
                    </div>
                  </div>
                </div>
                <div className="legend-container">
                  <div className="legend-bar">
                    {legendItems.map((item) => (
                      <div key={item.label} className="legend-chip">
                        <span className={`legend-dot ${item.status}`}></span>
                        <span className="legend-label">{item.label}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* ---- TIMELINE VIEW ---- */}
              {view === "Timeline" && (
                <div className="timeline-wrapper">
                  <div className="timeline-header sticky-header">
                    <div className="tech-col-header sticky-tech-header">
                      Technician
                    </div>
                    <div className="time-grid">
                      {timeSlotList?.data?.TimeSlot?.map((slot) => (
                        <div key={slot.ID} className="time-cell">
                          {slot.time}
                        </div>
                      ))}

                      {/* ✅ Header line — carries the time badge via ::after */}
                      <div
                        className="current-time-line"
                        style={{ left: `${currentTimeLeft}%` }}
                        data-time={currentTimeLabel}
                      />
                    </div>
                  </div>

                  {technicianListData?.data?.technician.map((tech) => (
                    <div key={tech.ID} className="timeline-row">
                      <div className="tech-col sticky-tech">
                        {tech.fullName}
                      </div>
                      <div className="time-grid position-relative">
                        {/* Hour cells (for dashed grid) */}
                        {timeSlotList?.data?.TimeSlot.map((slot) => (
                          <div
                            key={slot.ID}
                            className="time-cell"
                            onDoubleClick={() => {
                              if (!popoverOpen) {
                                handleAddNewJob(tech, slot, currentDate);
                              }
                            }}
                          ></div>
                        ))}

                        <div
                          className="current-time-line"
                          style={{ left: `${currentTimeLeft}%` }}
                        ></div>
                        {filteredJobs
                          ?.filter((j) => j.technician?.ID === tech.ID)
                          .map((job, index) => {
                            const startHour = new Date(
                              job.scheduledFrom,
                            ).getHours();
                            const endHour = new Date(
                              job.scheduledTo,
                            ).getHours();
                            const startPercent = (startHour / 24) * 100;
                            const widthPercent =
                              ((endHour - startHour) / 24) * 100;
                            return (
                              <div
                                key={job.ID}
                                id={`Popover-${job.ID}`}
                                className={`job-block ${jobColor[job.jobStatus]
                                  }`}
                                style={{
                                  left: `${startPercent}%`,
                                  width: `${widthPercent}%`,
                                }}
                                onMouseEnter={() => setPopoverOpen(`${job.ID}`)}
                                onMouseLeave={() => setPopoverOpen(null)}
                                onDoubleClick={(e) => {
                                  e.stopPropagation();
                                  // handleEditJob(job);
                                }}
                              >
                                <div className="job-title">
                                  {job?.customer?.name}
                                </div>
                                <div className="job-title">
                                  {WORK_ORDER}: {job.ID}
                                </div>

                                <Popover
                                  placement="auto"
                                  isOpen={popoverOpen === `${job.ID}`}
                                  target={`Popover-${job.ID}`}
                                  toggle={() =>
                                    setPopoverOpen(
                                      popoverOpen === `${job.ID}`
                                        ? null
                                        : `${job.ID}`,
                                    )
                                  }
                                  trigger="hover"
                                  className="shadow border-0"
                                  popperClassName="popover-wide"
                                >
                                  <PopoverHeader className="bg-white border-0 pb-0">
                                    <div className="d-flex justify-content-between align-items-center">
                                      <h4 className="text-dark mb-2">
                                        {job.customer.name}
                                      </h4>
                                      <div className="d-flex justify-content-between align-items-center">
                                        <Button
                                          color="link"
                                          size="sm"
                                          className="action-btn rounded-circle"
                                          onClick={() => {
                                            const encodedId = urlEncodedId(
                                              job.ID,
                                            );
                                            navigate(
                                              `/admin/jobs/${encodedId}/details`,
                                            );
                                          }}
                                        >
                                          <i className="fa-solid fa-up-right-and-down-left-from-center" />
                                        </Button>
                                      </div>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center">
                                      <span className="text-muted">
                                        {WORK_ORDER} No:{" "}
                                        <span className="text-default">
                                          {job.ID}
                                        </span>
                                      </span>
                                      <span
                                        className={`badge rounded-pill px-3 py-1 job-status ${jobColor[job.jobStatus]
                                          }`}
                                      >
                                        {formatSchedulerStatus(job.jobStatus)}
                                      </span>
                                    </div>
                                  </PopoverHeader>

                                  <PopoverBody className="pt-2 pb-3 px-3">
                                    <Row className="mb-1">
                                      <Col xs="12">
                                        <div className="jobData">
                                          <span>Type:</span>
                                          <span className="text-muted font-weight-bold ml-2">
                                            {job.jobTypeID.name || "-"}
                                          </span>
                                        </div>
                                      </Col>
                                    </Row>
                                    <Row className="mb-1">
                                      <Col xs="12">
                                        <div className="jobData">
                                          <span>Time:</span>
                                          <span className="text-muted font-weight-bold ml-2">
                                            {job.scheduledFrom} –{" "}
                                            {job.scheduledTo}
                                          </span>
                                        </div>
                                      </Col>
                                    </Row>
                                    <Row className="mb-1">
                                      <Col xs="12">
                                        <div className="jobData">
                                          <span>Problem by Client:</span>
                                          <span className="text-muted font-weight-bold ml-2">
                                            {job.clientNote || "-"}
                                          </span>
                                        </div>
                                      </Col>
                                    </Row>
                                    <Row className="mb-1">
                                      <Col xs="12">
                                        <div className="jobData">
                                          <span>Location:</span>
                                          <span className="text-muted font-weight-bold ml-2">
                                            {job.customerLocation.regionResponce
                                              .name || "-"}
                                          </span>
                                        </div>
                                      </Col>
                                    </Row>
                                  </PopoverBody>
                                </Popover>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* ---- WEEK VIEW ---- */}
              {view === "Week" && (
                <div className="week-view">
                  <div className="week-header sticky-header">
                    <div className="tech-col-header sticky-tech-header">
                      Technician
                    </div>
                    <div className="week-days">
                      {/* {weekDays.map((day) => (
                        <div key={day} className="week-day-cell">
                          {day}
                        </div>
                      ))} */}
                      {weekDays.map((d) => (
                        <div
                          key={d.label}
                          className="week-day-cell text-center"
                        >
                          <div className="fw-semibold">{d.label}</div>
                          <div className="small text-muted">
                            {d.date.getDate().toString().padStart(2, "0")}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {technicianListData?.data?.technician.map((tech) => (
                    <div key={tech.ID} className="timeline-row">
                      <div className="tech-col sticky-tech">
                        {tech.fullName}
                      </div>

                      <div className="week-days position-relative">
                        {weekDays.map((day) => {
                          const jobsForSlot = filteredJobs?.filter(
                            (j) =>
                              j.technician.ID === tech.ID &&
                              new Date(j.scheduledFrom).toLocaleDateString(
                                "en-US",
                                {
                                  weekday: "short",
                                },
                              ) == day?.label,
                          );
                          return (
                            <div
                              key={day}
                              className="week-day-slot"
                              onDoubleClick={(e) => {
                                if (popoverOpen) return;
                                if (jobsForSlot.length === 0) {
                                  handleAddNewJob(tech, day, currentDate);
                                }
                              }}
                            >
                              {jobsForSlot.map((job) => (
                                <div
                                  key={job.ID}
                                  id={`Popover-${job.ID}`}
                                  className={`job-card ${jobColor[job.jobStatus]}`}
                                  onMouseEnter={() =>
                                    setPopoverOpen(`${job.ID}`)
                                  }
                                  onMouseLeave={() => setPopoverOpen(null)}
                                  onDoubleClick={(e) => {
                                    e.stopPropagation();
                                    // handleEditJob(job);
                                  }}
                                >
                                  <div className="job-title">
                                    {job.customer?.name}
                                  </div>
                                  <div className="job-title">
                                    {WORK_ORDER} No: {job?.ID}
                                  </div>

                                  <Popover
                                    placement="auto"
                                    isOpen={popoverOpen === `${job.ID}`}
                                    target={`Popover-${job.ID}`}
                                    toggle={() =>
                                      setPopoverOpen(
                                        popoverOpen === `${job.ID}`
                                          ? null
                                          : `${job.ID}`,
                                      )
                                    }
                                    trigger="hover"
                                    className="shadow border-0"
                                    popperClassName="popover-wide"
                                  >
                                    <PopoverHeader className="bg-white border-0 pb-0">
                                      <div className="d-flex justify-content-between align-items-center">
                                        <h4 className="text-dark mb-2">
                                          {job.customer?.name}
                                        </h4>
                                        <div className="d-flex justify-content-between align-items-center">
                                          <Button
                                            color="link"
                                            size="sm"
                                            className="action-btn rounded-circle"
                                            onClick={() => {
                                              const encodedId = urlEncodedId(
                                                job.ID,
                                              );
                                              navigate(
                                                `/admin/jobs/${encodedId}/details`,
                                              );
                                            }}
                                          >
                                            <i className="fa-solid fa-up-right-and-down-left-from-center" />
                                          </Button>
                                        </div>
                                      </div>
                                      <div className="d-flex justify-content-between align-items-center">
                                        <span className="text-muted">
                                          {WORK_ORDER} No:{" "}
                                          <span className="text-default">
                                            {job.ID}
                                          </span>
                                        </span>
                                        <span
                                          className={`badge rounded-pill px-3 py-1 job-status ${jobColor[job.jobStatus]
                                            }`}
                                        >
                                          {formatSchedulerStatus(job.jobStatus)}
                                        </span>
                                      </div>
                                    </PopoverHeader>

                                    <PopoverBody className="pt-2 pb-3 px-3">
                                      <Row className="mb-1">
                                        <Col xs="12">
                                          <div className="jobData">
                                            <span>Type:</span>
                                            <span className="text-muted font-weight-bold ml-2">
                                              {job.jobTypeID?.name || "-"}
                                            </span>
                                          </div>
                                        </Col>
                                      </Row>
                                      <Row className="mb-1">
                                        <Col xs="12">
                                          <div className="jobData">
                                            <span>Time:</span>
                                            <span className="text-muted font-weight-bold ml-2">
                                              {job.scheduledFrom}–{" "}
                                              {job.scheduledTo}
                                            </span>
                                          </div>
                                        </Col>
                                      </Row>
                                      <Row className="mb-1">
                                        <Col xs="12">
                                          <div className="jobData">
                                            <span>Problem by Client:</span>
                                            <span className="text-muted font-weight-bold ml-2">
                                              {job.clientNote || "-"}
                                            </span>
                                          </div>
                                        </Col>
                                      </Row>
                                      <Row className="mb-1">
                                        <Col xs="12">
                                          <div className="jobData">
                                            <span>Location:</span>
                                            <span className="text-muted font-weight-bold ml-2">
                                              {job.customerLocation.address ||
                                                "-"}
                                            </span>
                                          </div>
                                        </Col>
                                      </Row>
                                    </PopoverBody>
                                  </Popover>
                                </div>
                              ))}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* ---- DAY VIEW ---- */}
              {view === "Day" && (
                <div className="day-view">
                  <div className="day-header sticky-header">
                    <div className="tech-col-header sticky-tech-header">
                      Technician
                    </div>
                    <div className="day-date">
                      {currentDate.toLocaleDateString("en-US", {
                        weekday: "long",
                        day: "2-digit",
                        month: "long",
                        year: "numeric",
                      })}
                    </div>
                  </div>

                  {technicianListData?.data?.technician.map((tech) => (
                    <div key={tech.id} className="day-row">
                      <div className="tech-col sticky-tech">
                        {tech.fullName}
                      </div>
                      <div className="hour-grid position-relative">
                        {/* Hour lines */}
                        {timeSlotList?.data?.TimeSlot.map((time, idx) => (
                          <div
                            key={idx}
                            className="hour-cell"
                            onDoubleClick={(e) => {
                              if (!popoverOpen) {
                                handleAddNewJob(tech, time, currentDate);
                              }
                            }}
                          >
                            <div className="hour-label">{time}</div>
                            <div className="hour-line" />
                          </div>
                        ))}

                        <div
                          className="current-time-line vertical-line"
                          data-time={currentTimeLabel}
                        >
                          <span className="current-time-dot" />
                        </div>

                        {/* jobs positioned by startTime/endTime time */}
                        {filteredJobs
                          ?.filter((j) => j.technician.id === tech.id)
                          .map((job) => {
                            const top = (job.startTime / 25) * 100;
                            const height =
                              ((job.endTime - job.startTime) / 25) * 100;
                            return (
                              <div
                                key={job.ID}
                                id={`Popover-${job.ID}`}
                                className={`job-block-vertical ${jobColor[job.jobStatus]
                                  }`}
                                style={{
                                  top: `${top + 1}%`,
                                  height: `${height}%`,
                                }}
                                onMouseEnter={() => setPopoverOpen(`${job.ID}`)}
                                onMouseLeave={() => setPopoverOpen(null)}
                                onDoubleClick={(e) => {
                                  e.stopPropagation();
                                  // handleEditJob(job);
                                }}
                              >
                                <div className="job-title">
                                  {job.customer.name}
                                </div>
                                <div className="job-title">
                                  {WORK_ORDER} No: {job.ID}
                                </div>

                                <Popover
                                  placement="auto"
                                  isOpen={popoverOpen === `${job.ID}`}
                                  target={`Popover-${job.ID}`}
                                  toggle={() =>
                                    setPopoverOpen(
                                      popoverOpen === `${job.ID}`
                                        ? null
                                        : `${job.ID}`,
                                    )
                                  }
                                  trigger="hover"
                                  className="shadow border-0"
                                  popperClassName="popover-wide"
                                >
                                  <PopoverHeader className="bg-white border-0 pb-0">
                                    <div className="d-flex justify-content-between align-items-center">
                                      <h4 className="text-dark mb-2">
                                        {job.customer.name}
                                      </h4>
                                      <div className="d-flex justify-content-between align-items-center">
                                        <Button
                                          color="link"
                                          size="sm"
                                          className="action-btn rounded-circle"
                                          onClick={() => {
                                            const encodedId = urlEncodedId(
                                              job.ID,
                                            );
                                            navigate(
                                              `/admin/jobs/${encodedId}/details`,
                                            );
                                          }}
                                        >
                                          <i className="fa-solid fa-up-right-and-down-left-from-center" />
                                        </Button>
                                      </div>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center">
                                      <span className="text-muted">
                                        {WORK_ORDER} No:{" "}
                                        <span className="text-default">
                                          {job.ID}
                                        </span>
                                      </span>
                                      <span
                                        className={`badge rounded-pill px-3 py-1 job-status ${jobColor[job.jobStatus]
                                          }`}
                                      >
                                        {formatSchedulerStatus(job.jobStatus)}
                                      </span>
                                    </div>
                                  </PopoverHeader>

                                  <PopoverBody className="pt-2 pb-3 px-3">
                                    <Row className="mb-1">
                                      <Col xs="12">
                                        <div className="jobData">
                                          <span>Type:</span>
                                          <span className="text-muted font-weight-bold ml-2">
                                            {job.jobTypeID?.name || "-"}
                                          </span>
                                        </div>
                                      </Col>
                                    </Row>
                                    <Row className="mb-1">
                                      <Col xs="12">
                                        <div className="jobData">
                                          <span>Time:</span>
                                          <span className="text-muted font-weight-bold ml-2">
                                            {job.scheduledFrom} –{" "}
                                            {job.scheduledTo}
                                            :00
                                          </span>
                                        </div>
                                      </Col>
                                    </Row>
                                    <Row className="mb-1">
                                      <Col xs="12">
                                        <div className="jobData">
                                          <span>Problem by Client:</span>
                                          <span className="text-muted font-weight-bold ml-2">
                                            {job.clientNote || "-"}
                                          </span>
                                        </div>
                                      </Col>
                                    </Row>
                                    <Row className="mb-1">
                                      <Col xs="12">
                                        <div className="jobData">
                                          <span>Location:</span>
                                          <span className="text-muted font-weight-bold ml-2">
                                            {job.customerLocation.address ||
                                              "-"}
                                          </span>
                                        </div>
                                      </Col>
                                    </Row>
                                  </PopoverBody>
                                </Popover>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* ---- Month VIEW ---- */}
              {view === "Month" && (
                <div className="month-view">
                  {/* Header */}
                  <div className="month-header sticky-header">
                    <div className="tech-col-header sticky-tech-header">
                      Technician
                    </div>

                    <div className="month-days">
                      {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map(
                        (d) => (
                          <div key={d} className="month-day-cell">
                            {d}
                          </div>
                        ),
                      )}
                    </div>
                  </div>

                  {/* Month view*/}
                  {(() => {
                    const current = new Date();
                    const year = current.getFullYear();
                    const month = current.getMonth();

                    // Start day of month: (0 = Sun and sat = 6)
                    const startDay = new Date(year, month, 1).getDay();

                    // Total days in month
                    //suppose 1 dec 2025 -> (2025 ,11+1= 12  ,0 -> to check day before 1st dec)
                    const totalDays = new Date(year, month + 1, 0).getDate();

                    // Build 42 cells (6 weeks)  // if any month starts on friday has 31 need 6 week grid
                    const monthCells = Array.from({ length: 42 }).map(
                      (_, i) => {
                        const dateNum = i - startDay + 1;
                        return dateNum > 0 && dateNum <= totalDays
                          ? dateNum
                          : "";
                      },
                    );

                    return technicianListData?.data?.technician.map((tech) => (
                      <div key={tech.ID} className="month-row">
                        {/* Technician Column */}
                        <div className="tech-col sticky-tech">
                          {tech.fullName}
                        </div>

                        {/* Month Grid */}
                        <div className="month-grid position-relative">
                          {monthCells.map((date, i) => {
                            const today = current.getDate();
                            const isToday = date === today;

                            // Correct job matching for this technician and date
                            const jobsForDate =
                              date !== ""
                                ? filteredJobs.filter((j) => {
                                  const jobDate = new Date(
                                    j.scheduledFrom,
                                  ).getDate();
                                  return (
                                    j.technician.ID === tech.ID &&
                                    jobDate === date
                                  );
                                })
                                : [];
                            return (
                              <div
                                key={i}
                                className={`month-cell ${isToday ? "today-highlight" : ""
                                  }`}
                                onDoubleClick={() => {
                                  if (!popoverOpen && date !== "")
                                    handleAddNewJob(tech, date, current);
                                }}
                              >
                                {/* Date Label */}
                                <div className="date-label">{date}</div>

                                {/* Jobs */}
                                <div className="job-container">
                                  {jobsForDate.map((job) => (
                                    <div
                                      key={job.ID}
                                      className={`job-mini ${jobColor[job.jobStatus]
                                        }`}
                                      id={`Popover-${job.ID}`}
                                      onMouseEnter={() =>
                                        setPopoverOpen(`${job.ID}`)
                                      }
                                      onMouseLeave={() => setPopoverOpen(null)}
                                      onDoubleClick={(e) => {
                                        e.stopPropagation();
                                        // handleEditJob(job);
                                      }}
                                    >
                                      <div className="job-title">
                                        {job.customer.name}
                                      </div>
                                      <div className="job-title">
                                        {WORK_ORDER} No: {job.ID}
                                      </div>

                                      {/* POPUP */}
                                      <Popover
                                        placement="auto"
                                        isOpen={popoverOpen === `${job.ID}`}
                                        target={`Popover-${job.ID}`}
                                        trigger="hover"
                                        toggle={() =>
                                          setPopoverOpen(
                                            popoverOpen === `${job.ID}`
                                              ? null
                                              : `${job.ID}`,
                                          )
                                        }
                                        className="shadow border-0"
                                        popperClassName="popover-wide"
                                      >
                                        <PopoverHeader className="bg-white border-0 pb-0">
                                          <div className="d-flex justify-content-between align-items-center">
                                            <h4 className="text-dark mb-2">
                                              {job.customer.name}
                                            </h4>
                                            <div className="d-flex justify-content-between align-items-center">
                                              <Button
                                                color="link"
                                                size="sm"
                                                className="action-btn rounded-circle"
                                                onClick={() => {
                                                  const encodedId =
                                                    urlEncodedId(job.ID);
                                                  navigate(
                                                    `/admin/jobs/${encodedId}/details`,
                                                  );
                                                }}
                                              >
                                                <i className="fa-solid fa-up-right-and-down-left-from-center" />
                                              </Button>
                                            </div>
                                          </div>

                                          <div className="d-flex justify-content-between align-items-center">
                                            <span className="text-muted">
                                              {WORK_ORDER} No:{" "}
                                              <span className="text-default">
                                                {job.ID}
                                              </span>
                                            </span>

                                            <span
                                              className={`badge rounded-pill px-3 py-1 job-status ${jobColor[job.jobStatus]
                                                }`}
                                            >
                                              {formatSchedulerStatus(job.jobStatus)}
                                            </span>
                                          </div>
                                        </PopoverHeader>

                                        <PopoverBody className="pt-2 pb-3 px-3">
                                          <Row className="mb-1">
                                            <Col xs="12">
                                              <div className="jobData">
                                                <span>Type:</span>
                                                <span className="text-muted font-weight-bold ml-2">
                                                  {job.jobTypeID?.name || "-"}
                                                </span>
                                              </div>
                                            </Col>
                                          </Row>

                                          <Row className="mb-1">
                                            <Col xs="12">
                                              <div className="jobData">
                                                <span>Time:</span>
                                                <span className="text-muted font-weight-bold ml-2">
                                                  {job.scheduledFrom}–{" "}
                                                  {job.scheduledTo}:00
                                                </span>
                                              </div>
                                            </Col>
                                          </Row>

                                          <Row className="mb-1">
                                            <Col xs="12">
                                              <div className="jobData">
                                                <span>Problem by Client:</span>
                                                <span className="text-muted font-weight-bold ml-2">
                                                  {job.clientNote || "-"}
                                                </span>
                                              </div>
                                            </Col>
                                          </Row>

                                          <Row>
                                            <Col xs="12">
                                              <div className="jobData">
                                                <span>Location:</span>
                                                <span className="text-muted font-weight-bold ml-2">
                                                  {job.customerLocation
                                                    ?.address || "-"}
                                                </span>
                                              </div>
                                            </Col>
                                          </Row>
                                        </PopoverBody>
                                      </Popover>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    ));
                  })()}
                </div>
              )}
            </CardBody>
          </Card>

          {selectedSlot && (
            <JobSlotCard
              selectedSlot={selectedSlot}
              updatePage={updatePage}
              onClose={onClose}
              region={selectDropdownValues?.region}
            />
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default JobScheduler;
